import { useState } from 'react'
import { faqPourCasquette, faqRecherche } from '../../content/faq'
import { useTheme } from '../../theme'
import { MVP } from '../../mvp'
import { avecAlpha } from '../../lib/couleurs'

/**
 * Aide & contact — ecran d'entree (prototype v7.4).
 *
 * Une recherche transverse en haut, puis TROIS portes. La recherche prime :
 * des qu'on tape, les portes s'effacent au profit des resultats — on ne fait pas
 * lire trois choix a quelqu'un qui sait deja ce qu'il cherche.
 */
function AidePage({ tc, ts, cardBg, hubMode, onRina, onFaq, onContact, onOuvrirQuestion }) {
  const { isWeb3 } = useTheme()
  const [q, setQ] = useState('')
  const cats = faqPourCasquette(hubMode)
  const resultats = faqRecherche(q, cats)
  const nbReponses = cats.reduce((n, c) => n + c.items.length, 0)

  const portes = [
    // MVP (S62) : la porte RINA n'est proposee que si la conversation est ouverte
    ...(MVP.RINA_CHAT ? [{ e: '🦊', t: 'Demander à RINA', s: 'Réponse immédiate, à toute heure', c: 'rgb(var(--c-primary))', go: onRina }] : []),
    { e: '❓', t: 'Questions fréquentes', s: `${nbReponses} réponses pour votre casquette`, c: 'rgb(var(--c-teal))', go: onFaq },
    { e: '💬', t: 'Nous contacter', s: 'WhatsApp ou email — une vraie personne', c: 'rgb(var(--c-green))', go: onContact },
  ]

  return (
    <>
      {/* Recherche transverse — filtre la FAQ a la volee */}
      <div className={`rounded-[20px] border px-4 py-3 flex items-center gap-2.5 animate-fade-up ${cardBg}`}>
        <span className="text-[15px]">🔎</span>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Une question ? Tapez un mot…"
          aria-label="Rechercher dans l’aide"
          className={`flex-1 min-w-0 bg-transparent outline-none text-sm ${tc}`}
        />
        {q && (
          <button onClick={() => setQ('')} aria-label="Effacer"
            className={`w-[22px] h-[22px] rounded-full text-xs font-extrabold flex-shrink-0 ${tc}`}
            style={{ background: 'rgba(7,62,61,0.08)' }}>×</button>
        )}
      </div>

      {q.trim() ? (
        <div className="mt-3">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] mx-0.5 mb-2.5 text-teal">
            {resultats.length} résultat{resultats.length > 1 ? 's' : ''}
          </p>
          {resultats.length === 0 ? (
            <div className={`rounded-[22px] border px-4 py-[18px] text-center ${cardBg}`}>
              <p className={`text-[13.5px] font-bold ${tc}`}>Rien trouvé sur « {q.trim()} »</p>
              <p className={`text-xs leading-relaxed mt-1.5 ${ts}`}>
                Ça arrive — et c’est utile de le savoir. Posez la question à RINA, ou écrivez-nous :
                on ajoutera la réponse ici.
              </p>
              <button onClick={onContact}
                className="mt-3 w-full py-3 rounded-2xl text-white text-[13.5px] font-extrabold"
                style={{ background: 'linear-gradient(135deg, rgb(var(--c-primary)), #e8703a)' }}>
                Poser ma question à l’équipe
              </button>
            </div>
          ) : (
            <div className={`rounded-[22px] border overflow-hidden ${cardBg}`}>
              {resultats.map((it, i) => (
                <button key={it.id} onClick={() => { setQ(''); onOuvrirQuestion(it.id) }}
                  className={`w-full flex items-center gap-3 px-[15px] py-[13px] text-left active:scale-[0.99] transition-transform ${
                    i > 0 ? `border-t ${isWeb3 ? 'border-white/5' : 'border-ink/[0.07]'}` : ''
                  }`}>
                  <span className="text-base flex-shrink-0">{it.cat.ico}</span>
                  <span className="flex-1 min-w-0">
                    <span className={`block text-[13.5px] font-bold ${tc}`}>{it.q}</span>
                    <span className={`block text-[11px] ${ts}`}>{it.cat.titre}</span>
                  </span>
                  <span className={`text-[13px] ${ts}`}>›</span>
                </button>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className="flex flex-col gap-2.5 mt-3.5">
          {portes.map((p) => (
            <button key={p.t} onClick={p.go}
              className={`w-full flex items-center gap-3.5 px-4 py-4 rounded-[22px] border text-left active:scale-[0.99] transition-transform animate-fade-up ${cardBg}`}>
              <span className="w-11 h-11 rounded-[15px] flex-shrink-0 flex items-center justify-center text-[21px]"
                style={{ background: avecAlpha(p.c, 0.12), border: '1px solid rgba(255,255,255,0.7)' }}>{p.e}</span>
              <span className="flex-1 min-w-0">
                <span className={`block text-[14.5px] font-bold ${tc}`}>{p.t}</span>
                <span className={`block text-[11.5px] mt-0.5 ${ts}`}>{p.s}</span>
              </span>
              <span className={`text-sm ${ts}`}>›</span>
            </button>
          ))}
        </div>
      )}
    </>
  )
}

export default AidePage
